import { useMemo } from 'react'

import { resultSetToOptionsList } from 'cube/helpers'

import { type SelectOption } from '@driftt/dds'
import { type CubeQuery, useCubeQuery } from '@driftt/dds.reports'

interface FilterOptionsResult {
  optionsList: SelectOption[]
}

/**
 * Hook that manages fetching and formatting cube reports page-level filter options.
 * @returns { FilterOptionsResult }
 */
export const useCubeFilterOptionsList = (
  cubeQuery: CubeQuery,
  labelDimensionKey: string,
  valueDimensionKey: string
): FilterOptionsResult => {
  const { data } = useCubeQuery({
    query: cubeQuery,
  })

  const optionsList = useMemo(() => {
    return resultSetToOptionsList(labelDimensionKey, valueDimensionKey, data)
  }, [data, labelDimensionKey, valueDimensionKey])

  return useMemo(
    () => ({
      optionsList,
    }),
    [optionsList]
  )
}
